import { createFileRoute, redirect } from '@tanstack/react-router'

import { isProfileTab } from '#pages/Profile/helpers'

interface IProfileSearch {
  tab?: string
}

export const Route = createFileRoute('/_authenticated/profile')({
  validateSearch: (search: Record<string, unknown>): IProfileSearch => ({
    tab: typeof search.tab === 'string' && isProfileTab(search.tab) ? search.tab : undefined,
  }),
  beforeLoad: ({ search }): void => {
    if (search.tab === undefined) return
    if (search.tab === 'card') throw redirect({ to: '/card' })
    if (search.tab === 'budget') throw redirect({ to: '/budget' })
    if (search.tab === 'settings') throw redirect({ to: '/settings' })
    throw redirect({ to: '/profile' })
  },
})
